<template>
  <div
    class="font-bold"
    :class="{'text-danger': isDiscounted }"
  >
    {{ formatCurrency(finalPrice) }}
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ProductFinalPrice',
  props: {
    finalPrice: {
      type: Number,
      required: true,
    },
    isDiscounted: {
      type: Boolean,
      default: false,
    },
  },
  setup() {

    const { formatCurrency } = useFormatCurrency();

    return { formatCurrency };

  },
});

</script>
